
import { Avatar, Col, Divider, Icon, List, Row } from "antd"
import { truncateLongText } from "o2o_layout"
import { OrganizationsNotContent, TypeOrganization } from "o2o_layout/lib/common/model"
import * as React from "react"
// import iconPango from "../../static/image/icon-pangocdp.svg"

interface Props {
    dataSources: TypeOrganization[]
    actionSelect: (item: TypeOrganization, targetUrl: string, callback: any) => void
    targetUrl: string
    orgs: OrganizationsNotContent
    isFirstLogin?: boolean
}

export const ListCompanySelectComponent = (props: Props) => {
    const { dataSources, actionSelect, targetUrl } = props
    const [loading, setLoading] = React.useState(false)

    const handleGetTwoCharacter = (name: string) => {
        const splitName = name.split(" ")
        if (splitName && splitName.length >= 2) {
            const result = splitName.slice(0, 2).map(word => word.substring(0, 1)).join('');
            return result
        }
        return name.slice(0, 2).toUpperCase()
    }
    {/*@ts-ignore */ }
    const orgUIs = props.orgs.orgUIs

    return (
        <List
            loading={loading || props?.isFirstLogin}
            className="list-company"
            dataSource={dataSources}
            renderItem={(item: TypeOrganization, index: number) => {
                const isFirstItem = index === 0
                const isLastItem = index === dataSources.length - 1;
                const themeColor = orgUIs && orgUIs[item.id] && orgUIs[item.id].themeColor !== null ? orgUIs[item.id].themeColor : "#ccc"

                return (
                    <List.Item
                        style={{ "--hover-color": themeColor } as React.CSSProperties}
                        key={item.id}
                        onClick={() => {
                            setLoading(true)
                            actionSelect(item, targetUrl, () => {
                                setLoading(false)
                            })
                        }}
                    >
                        <Row type="flex" align="top" justify="space-between" style={{
                            width: '100%',
                            marginBottom: isLastItem ? index === 0 ? 8 : 20 : 0,
                            marginTop: isFirstItem ? 20 : 0
                        }}>
                            <Col xs={4} xxl={3}>
                                <p>
                                    {/*@ts-ignore */}
                                    <Avatar src={item.imageLink} size={60} shape={"square"} style={{ backgroundColor: themeColor, borderRadius: 14 }}>
                                        <span className="no-hover-color">
                                            {handleGetTwoCharacter(item.name)}
                                        </span>
                                    </Avatar>
                                </p>
                            </Col>
                            <Col xs={20} xxl={21}>
                                <Row type="flex" align="middle" justify="space-between">
                                    <Col style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                                        <span className="hover-primary" style={{ fontSize: 17, fontWeight: 500, color: "#000" }}>{item.name}</span>
                                        <span className="hover-primary" style={{ fontSize: 15 }}>
                                            {item.website ? truncateLongText(item.website, 40) : "No website has been set up for this organization."}
                                        </span>
                                    </Col>
                                    <Col>
                                        <Icon type="right" style={{ fontSize: '17px', color: "black", opacity: '80%' }}></Icon>
                                    </Col>
                                </Row>
                                {!isLastItem && <Divider style={{ marginBottom: 0, marginTop: 30 }} />}
                            </Col>
                        </Row>

                    </List.Item>
                )
            }}
        />
    )
}



//  <List.Item.Meta
//                             avatar={
//                                 <>
//                                     {/*@ts-ignore */}
//                                     <Avatar src={item.imageLink} size={55} shape={"square"} style={{ backgroundColor: themeColor, borderRadius: 14 }}>
//                                         {handleGetTwoCharacter(item.name)}
//                                     </Avatar>
//                                 </>
//                             }
//                             title={<span style={{ fontSize: 18, fontWeight: 500, color: "#000" }}>{item.name}</span>}
//                             description={
//                                 <>

//                                     <span style={{ fontSize: 16 }}>
//                                         {truncateLongText(item.website || "", 40)}
//                                     </span>
//                                     <Divider style={{ width: '100%' }} />
//                                 </>
//                             }
//                         />